import { render } from "./ChannelTitle.vue?vue&type=template&id=8c4aa7fa&scoped=true"
import script from "./ChannelTitle.vue?vue&type=script&lang=js"
export * from "./ChannelTitle.vue?vue&type=script&lang=js"

import "../../../../../c/pages/dashboards.css?vue&type=style&index=0&id=8c4aa7fa&scoped=true&lang=css&external"
import "./ChannelTitle.vue?vue&type=style&index=1&id=8c4aa7fa&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4aa7fa"]])

export default __exports__